module.exports = __webpack_public_path__ + "./assets/banner-temp__7aef114c76d699b95212663dfdc48399.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-temp.png
// module id = 570
// module chunks = 37